import { memo, useEffect } from 'react';
import { DatePicker, DatePickerProps } from '@scale/scaleui';
import { useFilters } from '../FiltersProvider';
import _ from 'lodash';
import { format } from 'date-fns';

export const DATE_FORMAT = 'yyyy-MM-dd';

type DatePickerFilterProps = Pick<DatePickerProps, 'isRangePicker'> & {
  filterKey: string;
};

export const DatePickerFilter = memo(
  ({ filterKey, isRangePicker, ...otherProps }: DatePickerFilterProps) => {
    const { filterValue, setFilter, subscribeUrlFiltersKey, unSubscribeUrlFiltersKey } = useFilters(
      s => ({
        filterValue: _.get(s.filters, filterKey),
        setFilter: s.setFilter,
        subscribeUrlFiltersKey: s.subscribeUrlFiltersKey,
        unSubscribeUrlFiltersKey: s.unSubscribeUrlFiltersKey,
      }),
    );

    useEffect(() => {
      subscribeUrlFiltersKey(filterKey);
      return () => unSubscribeUrlFiltersKey(filterKey);
    }, [filterKey, subscribeUrlFiltersKey, unSubscribeUrlFiltersKey]);

    if (isRangePicker) {
      const value = [new Date(), new Date()];

      if (_.isArray(filterValue)) {
        const filterValue0 = filterValue[0];
        if (_.isString(filterValue0) && _.isDate(new Date(filterValue0))) {
          const [year0, month0, day0] = filterValue0.split('-');
          // months are 0-indexed
          value[0] = new Date(+year0, +month0 - 1, +day0);
        }
        const filterValue1 = filterValue[1];
        if (_.isString(filterValue1) && _.isDate(new Date(filterValue1))) {
          const [year1, month1, day1] = filterValue1.split('-');
          value[1] = new Date(+year1, +month1 - 1, +day1);
        }
      }

      return (
        <DatePicker
          {...otherProps}
          isRangePicker
          value={value}
          onChange={values =>
            setFilter(filterKey, [format(values[0], DATE_FORMAT), format(values[1], DATE_FORMAT)])
          }
        />
      );
    } else {
      let value = new Date();
      if (_.isString(filterValue) && _.isDate(new Date(filterValue))) {
        value = new Date(filterValue);
      }

      return (
        <DatePicker
          {...otherProps}
          value={value}
          onChange={values => setFilter(filterKey, format(values, DATE_FORMAT))}
        />
      );
    }
  },
);
